import { render, staticRenderFns } from "./EvidenceProducts.vue?vue&type=template&id=534143ac"
import script from "./EvidenceProducts.vue?vue&type=script&lang=ts"
export * from "./EvidenceProducts.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports